import Vue from 'vue'
import EstimateModal from '../components/top/input/estimate/EstimateModal'
import SheetPreviewModal from '../components/top/input/estimate/SheetPreviewModal'
import ImageViewer from '../components/top/product/common/ImageViewer'
import ImageSlide from '../components/top/product/common/ImageSlide'
import InviteUserModal from '../components/user/InviteUserModal'
import UserEditModal from '../components/user/DcUserEditModal'
import SaveModal from '../components/common/SaveModal'
import DcCameraPositionModal from '../components/output/DcCameraPositionModal'

/** 見積り/図面モーダル */
export const showEstimateModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-estimate-modal': EstimateModal },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-estimate-modal ref="estimateModalRef"
        :onOk="modalData.onOk"
        :onOutputCG="modalData.onOutputCG"
        :showSuccess="modalData.showSuccess"
        :titleDoor="modalData.titleDoor"
        :colorDoor="modalData.colorDoor"
        :titleCabine="modalData.titleCabine"
        :colorCabine="modalData.colorCabine"
        :titleCounter="modalData.titleCounter"
        :colorCounter="modalData.colorCounter"
        :priceData="modalData.priceData"
        :spaceJoincd="modalData.spaceJoincd"
        :dispOrderButton="modalData.dispOrderButton"
        :dcProductCount="modalData.dcProductCount"
        :isCalcDelivery="modalData.isCalcDelivery"
        :isDrawing="modalData.isDrawing"
        :corpData="modalData.corpData"
        :isProfitFlag="modalData.isProfitFlag"
        :isProductData="modalData.isProductData"
        :resrchFlag="modalData.resrchFlag"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 施工例ポップアップ */
export const showImageViewerModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-image-viewer-modal': ImageViewer },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-image-viewer-modal ref="imageViewerModalRef"
        :image="modalData.image"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 図面/製造指示書プレビュー */
export const showPreview = (modalData) => {
  let modal = new Vue({
    el: '#preview-modal',
    components: { 'dd-sheet-modal': SheetPreviewModal },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-sheet-modal ref="previewModalRef"
        :spaceJoincd="modalData.spaceJoincd"
        :isShowInfo="modalData.isShowInfo"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 招待メール */
export const showInviteUserModal = () => {
  let modal = new Vue({
    el: '#mail-modal',
    components: { 'dd-invite-user-modal': InviteUserModal },
    data () {
      return {
      }
    },
    methods: {
    },
    template: `
      <dd-invite-user-modal
      />
    `
  }).$children[0]
  modal.showModal()
}

/** ユーザーに関する処理のモーダル表示 */
export const showUserModal = (modalData) => {
  let modal = new Vue({
    el: '#add-user-modal',
    components: { 'dd-user-modal': UserEditModal },
    data () {
      return {
        userObj: modalData.userObj
      }
    },
    template: `
      <dd-user-modal ref="userModalRef"
        :userObj="userObj"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 商品情報を名前をつけて保存する */
export const showProductSave = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-save-modal': SaveModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-save-modal ref="saveModalRef"
        :title="modalData.title"
        :messages="modalData.messages"
        :modalType="modalData.modalType"
        :textAlign="modalData.textAlign"
        :okBtnLabel="modalData.okBtnLabel"
        :onOk="modalData.onOk"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 商品情報を名前をつけて保存する */
export const showCameraPosModal = (modalData) => {
  let modal = new Vue({
    el: '#camera-position-modal',
    components: { 'dd-camera-position-modal': DcCameraPositionModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-camera-position-modal ref="cameraPositionModalRef"
        :onOk="modalData.onOk"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** マニュアルプレビュー */
export const showImageSlideModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-image-slide-modal': ImageSlide },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-image-slide-modal ref="imageSlideModalRef"
        :imageList="modalData.imageList"
        :swiperOptions="modalData.swiperOptions"
      />
    `
  }).$children[0]
  modal.showModal()
}



// WEBPACK FOOTER //
// ./src/main/js/payment/utils/AppEc.js